export default "/react/seowizardIcon-4ad2a181.svg";